import { FC, useState } from "react";
import { StyledNavItemButton } from "../../NestedNavbar.styles";
import ChevronUp from "../../../../../assets/icons/UnumSync/chevron-up.svg";
import NavItem from "../NavItem";
import { navItem } from "types/CMS/Unum/Navbar/navbar";
import { navDraw } from "types/CMS/Unum/Navbar/navDraw";
import Icon from "components/CMSEnabled/Icon/Icon";

type navDrawProps = {
  draw: navDraw;
  depth: number;
  onClick: (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    navItem: navItem
  ) => void;
  activeLink?: string;
};

const NavDraw: FC<navDrawProps> = ({
  draw,
  depth = 0,
  onClick,
  activeLink,
}) => {
  const { id, icon, label, items } = draw;
  const [isOpen, setIsOpen] = useState(false);

  const drawToggle = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setIsOpen(!isOpen);
    onClick(e, draw);
  };
  return (
    <li key={id}>
      <StyledNavItemButton
        onClick={(e) => {
          drawToggle(e);
        }}
        aria-expanded={isOpen}
        aria-controls={`submenu-${id}`}
      >
        {icon && <Icon name={icon} width={20} height={20} />}
        <span>{label}</span>
        <ChevronUp
          width={16}
          height={16}
          viewBox="0 0 24 24"
          style={{
            marginLeft: "auto",
            transform: isOpen ? "rotate(0deg)" : "rotate(180deg)",
          }}
        />
      </StyledNavItemButton>
      {isOpen && (
        <ul id={`submenu-${id}`}>
          {items.map((item) => (
            <NavItem
              activeLink={activeLink}
              key={item.id}
              item={item}
              depth={depth + 1}
              onClick={onClick}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default NavDraw;